
import { Card } from 'antd';
const TopUsing = (props: any) => {
  return <Card title={"Top Using Companies"}></Card>;
};

export default TopUsing;
